import React, { lazy, Suspense } from 'react';
import DeviationPageLoader from './_partials/DeviationPageLoader';
import { PapiDeviation } from '@wix/da-papi-types';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '../utils/webpack/chunkRetry';

const DeviationPage = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "devpage", webpackPrefetch: true */
        './index'
      )
  )
);

const StashPage = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "devpage", webpackPrefetch: true */
        './StashPage'
      )
  )
);

export interface Props {
  deviation?: PapiDeviation;
  isWholePageLoading: boolean;
}

export const LoadableDeviationPage: React.FC<Props> = ({ isWholePageLoading, deviation }) => {
  if (isWholePageLoading) {
    return <DeviationPageLoader />;
  }

  return (
    <ErrorBoundary debugComponent="LoadableDeviationPage">
      <Suspense fallback={<DeviationPageLoader />}>
        {deviation?.isPublished && <DeviationPage deviation={deviation} />}
        {!deviation?.isPublished && <StashPage deviation={deviation} />}
      </Suspense>
    </ErrorBoundary>
  );
};
LoadableDeviationPage.displayName = 'LoadableDeviationPage';

export default LoadableDeviationPage;
